import * as CouponPageActionTypes from './CouponPageActionTypes';

export default CouponPageActionTypes;
